import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2 } from 'lucide-react';
import { Button } from './ui/button';
import { universities as fallbackUnis } from '../data/mock';
import { useUniversities } from '../hooks/useUniversities';
import { publicUniversityLogos } from '../lib/uniLogosApi';

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function PartnerLogos() {
  const list = useUniversities(fallbackUnis);
  const universities = list.length ? list : fallbackUnis;
  const [logos, setLogos] = useState({});

  useEffect(() => {
    let off = false;
    publicUniversityLogos()
      .then((m) => { if (!off) setLogos(m || {}); })
      .catch(() => {});
    return () => { off = true; };
  }, []);

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto max-w-7xl px-4 md:px-8">
        <div className="mb-10">
          <p className="text-sm font-semibold text-secondary uppercase tracking-widest mb-2 flex items-center gap-1.5">
            <Building2 className="h-4 w-4 text-brand" /> {universities.length}+ Partner Universities
          </p>
          <h3 className="font-serif text-3xl md:text-4xl font-bold text-primary mb-2">
            <span className="text-brand">WHO-approved universities,</span> verified by us and<br className="hidden md:block" /> reviewed on quality factors.
          </h3>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3">
          {universities.map((uni, i) => {
            const logoUrl = logos[uni.slug] ? `${BASE}${logos[uni.slug]}` : null;
            const code = uni.short || uni.name;
            return (
              <Link key={uni.slug || i} to={`/universities/${uni.slug}`}
                className="group flex flex-col items-center gap-2 bg-white border border-border rounded-xl p-3 hover:border-brand hover:shadow-md transition-all duration-200">
                <div className="w-full h-16 rounded-lg overflow-hidden flex items-center justify-center bg-muted">
                  {logoUrl ? (
                    <img src={logoUrl} alt={code} className="max-h-14 max-w-full object-contain" />
                  ) : (
                    <div className="h-10 w-10 rounded-full bg-primary text-white flex items-center justify-center font-serif font-bold text-sm group-hover:bg-brand group-hover:scale-105 transition-all">
                      {code.substring(0, 2)}
                    </div>
                  )}
                </div>
                <div className="text-center w-full">
                  <p className="text-[11px] font-bold text-primary leading-tight line-clamp-1">{code}</p>
                  <p className="text-[10px] text-muted-foreground leading-tight">{uni.city || 'Russia'}</p>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link to="/universities">
            <Button variant="outline" className="rounded-full border-brand text-brand hover:bg-brand hover:text-white gap-2 font-semibold">
              View All Universities in Detail <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
